module.exports = __webpack_public_path__ + "static/wherever-app.42eec10b.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/wherever-app.jpg
// module id = 1271
// module chunks = 4 5